import { Refresh2Light } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TableHeaderOrientation } from '../../header-orientation';

type Props = {
  orientation: TableHeaderOrientation;
  onToggle(): void;
  className?: string;
};

export const TableHeaderOrientationToggle = wrap<Props>(function TableHeaderOrientationToggle({
  orientation,
  onToggle,
  className,
}) {
  const { t } = useTranslation();
  const title =
    orientation === 'horizontal'
      ? t('displaySettings:switchHeadersToVertical')
      : t('displaySettings:switchHeadersToHorizontal');

  return (
    <Button
      type="button"
      variant="flat"
      className={className}
      title={title}
      icon={<Refresh2Light aria-hidden />}
      onClick={onToggle}
    />
  );
});
